import {CICOActionResponse, CICOItemIdsToAssignee} from 'constants/SampleStatusConstants';
import * as net from 'util/Net';

export function checkOut(
  itemIdsToAssignee: CICOItemIdsToAssignee,
  comment?: string
): Promise<CICOActionResponse> {
  return net.postJSONPromise({
    url: '/1/api/check-in-check-out:check-out',
    data: {
      // eslint-disable-next-line benchlint/no-spread-reduce
      itemIdsToAssigneeId: Object.entries(itemIdsToAssignee).reduce(
        (obj, [itemId, assignee]) => ({...obj, [itemId]: assignee.id}),
        {}
      ),
      comment,
    },
  });
}

export function checkIn(itemIds: Array<string>, comment?: string): Promise<CICOActionResponse> {
  return net.postJSONPromise({
    url: '/1/api/check-in-check-out:check-in',
    data: {
      itemIds,
      comment,
    },
  });
}

export function reserve(
  itemIdsToAssignee: CICOItemIdsToAssignee,
  comment?: string
): Promise<CICOActionResponse> {
  return net.postJSONPromise({
    url: '/1/api/check-in-check-out:reserve',
    data: {
      // eslint-disable-next-line benchlint/no-spread-reduce
      itemIdsToAssigneeId: Object.entries(itemIdsToAssignee).reduce(
        (obj, [itemId, assignee]) => ({...obj, [itemId]: assignee.id}),
        {}
      ),
      comment,
    },
  });
}
